'use client';

import cn from 'classnames';

import { useWindowWidth } from '@/hooks/useWindowWidth';

import { CarouselBase } from '../../CarouselBase';
import s from './FullwidthCarousel.module.scss';

const MockFullImages = [
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-1.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-2.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-3.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-4.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-5.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-6.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-8.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-9.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-12.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-13.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-14.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-15.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-16.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-17.png',
  'https://cdn.cloud.ru/backend/career/fullwidth-carousel/slide-19.png',
];

const FullwidthCarousel = () => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();
  return (
    <section className={cn(s.root)}>
      <CarouselBase
        slidesCount={MockFullImages.length}
        navigationClassName={s.navigation}
        withNavigation={!!windowWidth && windowWidth > MD}
        loop
        autoPlay
        analyticsName="fullwidth-carousel"
      >
        {MockFullImages.map((image, index) => {
          return <CarouselBase.Full key={index} image={image} />;
        })}
      </CarouselBase>
      <div className={s.textWrapper}>
        <span className={s.text}>Офис в Москве </span>
        <div className={s.textWrapperCustom}>
          <span className={s.text}>и коворкинги </span>
          <span className={s.text}>в городах России</span>
        </div>
      </div>
    </section>
  );
};

export { FullwidthCarousel };
